import styled from 'styled-components';
import { AlertStyled } from '../AlertStyled';

export const AlertStyledDS = styled(AlertStyled)`
    .wrapper {
        background: ${({ theme }) => theme.colors.primary};
    }
`;
